import React, {useState} from 'react';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import PopUpWithAnimation from '../../Shared/PopUpWithAnimation/PopUpWithAnimation';
import OtpExtendedPopup from '../../Block/SelfcareExtendedOtpButtonBlock/PopUp/OtpExtendedPopup';
import IdValidationPopup from '../../Block/OTPLoginBlock/Popups/idValidationPopup';
import authenticationProvider from '../../../utilities/authentication/authenticationProvider';
import helper from '../../../utilities/helper';
import Config from '../../../Config';
import {buildUrlAndOpenSameWindow} from '../../../utilities/StringHelpers/StringHelpers';

const AuthenticationPopUp = (props) => {
  return (
    <>
      {props.action == 'otpExtended' && (
        <PopUpWithAnimation className='selfcareExtendedOtpPopUp' isShow={true} onClose={() => goBack()}>
          <OtpExtendedPopup setShowPopUp={handleOnClose} showPopup={true} setOtpExtendedFinished={console.info('setOtpExtendedFinished')} />
        </PopUpWithAnimation>
      )}

      {props.action == 'identityCompletion' && (
        <PopUpWithAnimation className='selfcareExtendedOtpPopUp' isShow={true} onClose={() => goBack()}>
          <IdValidationPopup
            closeModal={() => {
              console.log('finished id validation with success');
            }}
          />
        </PopUpWithAnimation>
      )}

      {props.action == 'accountOnlyMessage' && (
        <PopUpWithAnimation
          className='selfcareExtendedOtpPopUp'
          isShow={true}
          onClose={() => goBack()}
          footerLink={{text: 'לא כרגע', onLinkClick: handleOnLinkClick}}>
          <div className='popup-account-only-message'>
            <div className='title-wrapper'> פעולה זו אפשרית לבעל החשבון בלבד </div>
            <div className='button-wrapper'>
              <BtnSubmit isBusiness={false} text='להזדהות בעל החשבון' onclick={handleOnContinue} formid='popup-account-only' />
            </div>
          </div>
        </PopUpWithAnimation>
      )}
    </>
  );

  function handleOnContinue() {
    const template = helper.getLoginTemplate();
    authenticationProvider.redirectToLogin(location.pathname, location.pathname, template);
  }

  function handleOnClose() {
    goBack();
  }

  function handleOnLinkClick() {
    goBack();
  }

  function goBack() {
    if (window.history.length > 1) {
      window.history.go(-1);
    } else {
      buildUrlAndOpenSameWindow(Config.lobbyUrl);
    }
  }
};

export default AuthenticationPopUp;
